import { type Static, Type } from "@sinclair/typebox"
import { IsoTimestampSchema } from "../schemas"

export const PLAYER_REPORT_STORAGE_KEY = "craft-force.player-reports"
export const PLAYER_REPORT_STORAGE_VERSION = 1

export const PlayerReportStatusSchema = Type.Union([
  Type.Literal("pending"),
  Type.Literal("reviewed"),
  Type.Literal("dismissed"),
])

export type PlayerReportStatus = Static<typeof PlayerReportStatusSchema>

export const PlayerReportSchema = Type.Object({
  id: Type.String({ minLength: 1 }),
  reporterTag: Type.String({ minLength: 1 }),
  reportedTag: Type.String({ minLength: 1 }),
  reason: Type.String({ minLength: 1 }),
  createdAt: IsoTimestampSchema,
  updatedAt: IsoTimestampSchema,
  status: PlayerReportStatusSchema,
})

export type PlayerReport = Static<typeof PlayerReportSchema>

export const PlayerReportStoreSchema = Type.Array(PlayerReportSchema)
export type PlayerReportStore = Static<typeof PlayerReportStoreSchema>

export const EMPTY_PLAYER_REPORT_STORE: PlayerReportStore = []

export function createPlayerReport(
  reporterTag: string,
  reportedTag: string,
  reason: string,
): PlayerReport {
  const now = new Date().toISOString()
  return {
    id: `report_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`,
    reporterTag: reporterTag.trim(),
    reportedTag: reportedTag.trim(),
    reason: reason.trim(),
    createdAt: now,
    updatedAt: now,
    status: "pending",
  }
}

export function updatePlayerReportStatus(
  reports: readonly PlayerReport[],
  reportId: string,
  status: PlayerReportStatus,
): PlayerReportStore {
  const updatedAt = new Date().toISOString()
  return reports.map((report) =>
    report.id === reportId ? { ...report, status, updatedAt } : report,
  )
}
